module.exports = __webpack_public_path__ + "img/VOFPlaceholder.ee1f632e.png";